import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Toast from "../../components/ToastContainer/CustomToast";
import httpCommon from "../../config/http-common";
import { rescheduleVisitor } from "../../slices/Invitations/InvitationsSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";
import CustomDateTimePicker from "../CustomInputs/CustomDateTimePicker";
import CancelButtons from "../DialogBoxComponent/CancelButtons";
import SubmitButtons from "../DialogBoxComponent/SubmitButtons";

export default function RescheduleVisitor(props) {
  const { darkMode } = useContext(ThemeContext);
  const { open, handleClose } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [changeDate, setDateChange] = useState(true);
  const [error, setError] = React.useState({
    scheduledStartDate: false,
    scheduledEndDate: false,
  });

  const [siteCurrentDateTime, setSiteCurrentDateTime] = useState(null);

  useEffect(() => {
    getSiteCurrentDateTime(props.siteId);
  }, []);

  const formatDayAndMonth = (numValue) => {
    if (numValue <= 0) {
      return "-" + (numValue + 12);
    }
    if (numValue < 10) {
      return "-0" + numValue;
    } else {
      return "-" + numValue;
    }
  };
  var today = new Date();
  var endDate =
    today.getFullYear() +
    formatDayAndMonth(today.getMonth() + 1) +
    formatDayAndMonth(today.getDate()) +
    "T23:59";
  var startDate =
    today.getFullYear() +
    formatDayAndMonth(today.getMonth() + 1) +
    formatDayAndMonth(today.getDate()) +
    "T" +
    (today.getHours() < 10 ? "0" + today.getHours() : today.getHours()) +
    ":" +
    (today.getMinutes() < 10 ? "0" + today.getMinutes() : today.getMinutes());

  const [state, setState] = React.useState({
    id: props.CustomerID,
    scheduledStartDate: startDate,
    scheduledEndDate: endDate,
    firstName: props?.ResheduleFirstName,
    lastName: props?.ResheduleLastName,
    siteTimeZone: props?.siteTimeZone,
  });

  console.log("start", state.scheduledStartDate);
  console.log("end", state.scheduledEndDate);

  const onFailure = (data) => {
    if (CommonUtil.isEmpty(data)) {
      Toast(t("COMMON000"), "error");
      return;
    }
    switch (data.code) {
      case "CVAE1021":
        setError({ ...error, scheduledStartDate: true });
        break;
      case "CVAE1022":
        setError({ ...error, scheduledEndDate: true });
        break;
      case "CVAE1023":
        setError({ ...error, scheduledEndDate: true });
        break;
    }
    Toast(data.message, "error");
  };

  const handleSumbit = () => {
    if (
      state.scheduledStartDate === null ||
      state.scheduledStartDate === undefined ||
      state.scheduledStartDate === ""
    ) {
      setError({ scheduledStartDate: true });
      Toast(t("INVITATIONFORM011"), "error");
      return;
    }

    if (
      state.scheduledEndDate === null ||
      state.scheduledEndDate === undefined ||
      state.scheduledEndDate === ""
    ) {
      setError({ scheduledEndDate: true });
      Toast(t("INVITATIONFORM012"), "error");
      return;
    }

    if (
      siteCurrentDateTime &&
      new Date(state.scheduledStartDate) < siteCurrentDateTime
    ) {
      Toast(t("INVITATIONFORM010"), "error");
      return;
    }

    if (new Date(state.scheduledStartDate) < new Date(state.scheduledEndDate)) {
      const formstate = {};
      formstate.scheduledStartDate = CommonUtil.formatLocalDateTime(
        state.scheduledStartDate,
      );
      formstate.scheduledEndDate = CommonUtil.formatLocalDateTime(
        state.scheduledEndDate,
      );
      formstate.id = state.id;
      formstate.firstName = state.firstName;
      formstate.lastName = state.lastName;
      formstate.siteTimeZone = props?.siteTimeZone;
      dispatch(rescheduleVisitor(formstate))
        .unwrap()
        .then((data) => {
          if (data.code === "CVAI0069") {
            handleClose(false);
            setDateChange(true);
            props.loadData();
            Toast(t("RESCHEDULEFORM001"), "success");
          } else {
            onFailure(data);
          }
        });
    } else {
      Toast(t("INVITATIONFORM003"), "error");
    }
  };

  const getSiteCurrentDateTime = (siteId) => {
    httpCommon
      .securedAxios()
      .get(`/web/visit/site/${siteId}/currectDateTime`)
      .then((response) => {
        if (
          response?.data?.code === "CVAI0000" &&
          response.data.data?.siteCurrentTime
        ) {
          const startDate = new Date(response.data.data.siteCurrentTime);
          const endOfSameDay = moment(startDate).endOf("day");
          setState((prev) => ({
            ...prev,
            scheduledStartDate: CommonUtil.formatLocalDateTime(startDate),
            scheduledEndDate: CommonUtil.formatLocalDateTime(endOfSameDay),
          }));
          setSiteCurrentDateTime(startDate);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <Dialog
        open={open}
        fullWidth={true}
        disableBackdropClick
        disableEscapeKeyDown
        BackdropProps={{
          style: {
            backdropFilter: "blur(5px)",
            // Adjust the opacity as needed
          },
        }}
      >
        <DialogTitle
          variant="h4"
          style={{
            backgroundColor: darkMode ? "#0E2A41" : "",
            color: darkMode ? "#fff" : "",
          }}
        >
          <IconButton
            aria-label="close"
            onClick={() => handleClose(false)}
            sx={{
              position: "absolute",
              right: 15,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          {t("RESCHEDULEFORM002")}
        </DialogTitle>
        <Divider
          variant="middle"
          style={{
            background: darkMode
              ? "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box"
              : "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box",
            height: "1px",
            opacity: 0.5,
          }}
        />

        <DialogContent
          style={{
            backgroundColor: darkMode ? "#0E2A41" : "",
            paddingBottom: "0px",
          }}
        >
          <Grid container spacing={2}>
            <Grid
              item
              sx={12}
              style={{
                width: "100%",
              }}
            >
              <CustomDateTimePicker
                onChange={(scheduledStartDate) =>
                  setState({
                    ...state,
                    scheduledStartDate: scheduledStartDate,
                  })
                }
                value={state.scheduledStartDate}
                minDateTime={siteCurrentDateTime}
                label={t("INVITESTARTDATEERROR1")}
                changeDate={changeDate}
                date={props.date}
              />
            </Grid>
            <Grid
              item
              sx={12}
              style={{
                width: "100%",
              }}
            >
              <CustomDateTimePicker
                onChange={(scheduledEndDate) =>
                  setState({
                    ...state,
                    scheduledEndDate: scheduledEndDate,
                  })
                }
                value={state.scheduledEndDate}
                minDateTime={
                  state.scheduledStartDate
                    ? new Date(state.scheduledStartDate)
                    : undefined
                }
                label={t("INVITESTARTDATEERROR2")}
                changeDate={changeDate}
                date={props.date}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          style={{
            justifyContent: "center",
            backgroundColor: darkMode ? "#0E2A41" : "",
          }}
        >
          <CancelButtons
            variant="contained"
            color="secondary"
            onClick={() => handleClose(false)}
          >
            <Typography variant="body1" style={{ textTransform: "none" }}>
              {t("COMMON008")}
            </Typography>
          </CancelButtons>
          <SubmitButtons variant="contained" onClick={handleSumbit}>
            <Typography variant="body1" style={{ textTransform: "none" }}>
              {t("COMMON007")}
            </Typography>
          </SubmitButtons>
        </DialogActions>
      </Dialog>
    </>
  );
}
